import React, { Component } from 'react';

import TreeA from './TreeA.js';
export default class Home extends React.Component {

    render() {
        return (
            <div>
               
                <TreeA id="rootid" name="Root" />
            </div>         
        );
    }
}